<template>
    <div class="p-0 dinlineb prelative">
        <div
            class="avatar-wrapper dinlineb prelative valign-middle pr-8 br-1 cpointer"
            @click="toggleList"
        >
            <div
                v-if="currentstaff.avatar"
                class="avatar avatar-big"
                :class="{ 'avatar-picture': hasPicture(currentstaff) }"
            >
                <img
                    v-if="hasPicture(currentstaff)"
                    :src="currentstaff.avatar.value"
                />
                <span v-else>
                    {{ currentstaff.avatar.value }}
                </span>
            </div>
            <div class="staff-detail dinlineb valign-middle ml-3">
                <div class="staff-name bold ellipsis">
                    {{ $filters.shortName(currentstaff.fullName) }}
                </div>
                <div class="staff-job gray-60">{{ currentstaff.position }}</div>
            </div>
            <i
                v-if="nbStaffs > 1"
                class="fa icon-caret-down primary-50 fs-3 mt-1 pabsolute top-right mr-5 mt-1"
            ></i>
        </div>

        <div v-show="displayList" class="staff-list pabsolute span_12 well px-3 pt-4">
            <div class="valign-middle prelative pb-5 pr-3 bb-1 cpointer" @click="toggleList">
                <div
                    v-if="currentstaff.avatar"
                    class="avatar avatar-big"
                    :class="{ 'avatar-picture': hasPicture(currentstaff) }"
                >
                    <img
                        v-if="hasPicture(currentstaff)"
                        :src="currentstaff.avatar.value"
                    />
                    <span v-else>
                        {{ currentstaff.avatar.value }}
                    </span>
                </div>
                <div class="staff-detail dinlineb valign-middle ml-3">
                    <div class="staff-name bold ellipsis">
                        {{ $filters.shortName(currentstaff.fullName) }}
                    </div>
                    <div class="staff-job gray-60">{{ currentstaff.position }}</div>
                </div>
                <i class="fa icon-caret-top-fillout primary-50 fs-3 pabsolute top-right mt-1"></i>
            </div>

            <el-input
                v-model="search"
                :placeholder="$t.__('common.actions.search')"
                clearable
                class="mt-3"
            ></el-input>

            <ul class="m-0 list-staffs ov-auto">
                <li v-for="staff in staffsList" :key="staff.id">
                    <a class="block p-2 my-2 hover-gray-0-bkg" :href="'/staff/' + staff.id">
                        <span
                            class="avatar"
                            :class="{ 'avatar-picture': hasPicture(staff) }"
                        >
                            <img v-if="hasPicture(staff)" :src="staff.avatar.value" />
                            <span v-else>
                                {{ staff.avatar.value }}
                            </span>
                        </span>
                        <div class="staff-detail dinlineb valign-middle ml-3">
                            <div class="fs-3 gray-100">{{ staff.fullName }}</div>
                            <div class="staff-job gray-60">{{ staff.position }}</div>
                        </div>
                    </a>
                </li>
            </ul>

            <a class="block acenter mt-3 fs-3 semibold" href="/staffs">{{
                $l10n.__('Voir tous les collaborateurs')
            }}</a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentStaffId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            displayList: false,
            currentstaff: {},
            staffsList: {},
            staffsListFull: {},
            nbStaffs: 0,
            nbStaffDisplay: 5,
            search: '',
        };
    },

    watch: {
        search(newVal) {
            if (newVal != '') {
                this.staffsList = Object.keys(this.staffsListFull)
                    .map((key) => this.staffsListFull[key]) // turn an array of keys into array of items.
                    .filter(
                        (staff) =>
                            staff.fullName
                                .toLowerCase()
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .indexOf(
                                    newVal
                                        .toLowerCase()
                                        .normalize('NFD')
                                        .replace(/[\u0300-\u036f]/g, ''),
                                ) > -1,
                    );
            } else {
                this.staffsList = this.staffsListFull;
            }
        },
    },

    created() {
        this.fetchStaffs();
    },

    methods: {
        fetchStaffs() {
            const self = this;

            var options = {};

            $.post(
                '/?_f=staff&action=getStaffsForCorp',
                options,
                function (data) {
                    self.staffsList = self.staffsListFull = data.staffsList;
                    self.currentstaff = data.staffsList['staff_' + self.currentStaffId];
                    delete self.staffsList['staff_' + self.currentStaffId];
                    self.nbStaffs = _.size(self.staffsList);
                },
                'json',
            );
        },
        toggleList() {
            if (this.nbStaffs >= 1) {
                this.displayList = !this.displayList;
            }
        },
        hasPicture(staff) {
            const type = staff?.avatar?.type;
            const validTypes = ['picture', 'externaluserpic', 'twitteruserpic'];
            return validTypes.includes(type);
        },
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;

.avatar-wrapper {
    min-width: 272px;
}

.staff-detail {
    width: 160px;
}

.staff-name {
    font-size: 20px;
}

.staff-list {
    background-color: $white;
    top: -24px;
    left: -16px;
    z-index: 99;
}

.list-staffs {
    max-height: 300px;
}
</style>
